import {Component, Input, ViewEncapsulation} from '@angular/core';
import {ReportTableRowParametersChannelStore} from './report-table-row-parameters-channel.store';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-report-table-row-parameters-channel',
  templateUrl: './report-table-row-parameters-channel.component.html',
  styleUrls: ['./report-table-row-parameters-channel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ReportTableRowParametersChannelStore]
})
export class ReportTableRowParametersChannelComponent {

  @Input('parameter') public set parameter(channel: string | null | undefined) {
    this._reportTableRowParametersChannelStore.init(channel);
  };

  public readonly channel$: Observable<string> = this._reportTableRowParametersChannelStore.channel$;
  public readonly slug$: Observable<string> = this._reportTableRowParametersChannelStore.slug$;

  constructor(
    private readonly _reportTableRowParametersChannelStore: ReportTableRowParametersChannelStore
  ) {}

}
